//
//
//
//
//
//

export default {
	name: 'InfinityScroll',
	props: {
		loading: {
			type: Boolean,
			required: true,
		},
		offset: {
			'type': Number,
			'default': 300,
		},
	},
	mounted() {
		this.$options.scrollObserver = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting && this.loading === false) {
				this.$emit('request');
			}
		}, { rootMargin: `${this.offset}px` });
		this.$options.scrollObserver.observe(this.$el);
	},
	beforeDestroy() {
		this.$options.scrollObserver.disconnect();
		this.$options.scrollObserver = null;
	},
};
